<ion-row *ngIf="tournament">
    <ion-col class="ion-no-padding ion-text-start">
        <div style="font-size: small;" [ngClass]="{ 'success-color': match.matchStatus==='IN_PROGRESS' }">
            <app-match-duration *ngIf="match?.matchStatus==='IN_PROGRESS'" [match]="match"></app-match-duration><span *ngIf="match?.matchStatus==='TBP' && match?.schedule?.scheduledTime">{{ getTime(match?.schedule?.scheduledTime) | date: 'shortTime' }}</span><span *ngIf="match.schedule?.courtId || getCourtName()"> | {{ match.schedule?.courtName || getCourtName() }}</span>
        </div>
    </ion-col>
    <ion-col style="font-size: small;" class="ion-no-padding ion-text-end">
        {{ match.event?.eventName | eventName }} - {{ match.roundName }}
    </ion-col>
</ion-row>